import { decodeEntities } from '../../helpers/stringHelpers'

const initialState = {
  sales: {},
  incrementTables: {},
  activeListings: []
}

const decodeListingSaleProperties = (listingSale) => (Object.assign({}, listingSale, {
  nextBidCalculation: decodeEntities(listingSale.nextBidCalculation)
}))

export default function listingSales (state, action) {
  if (typeof state === 'undefined') {
    return initialState
  }

  switch (action.type) {
    case 'LISTING_SALE_GET_SUCCESS': {
      const existingSale = state.sales[action.sale.listingUuid]
      return (existingSale && action.timestamp < existingSale.timestamp)
        ? state
        : Object.assign({}, state, {
          sales: Object.assign({}, state.sales, {
            [action.sale.listingUuid]: Object.assign({}, existingSale, decodeListingSaleProperties(action.sale), {
              timestamp: action.timestamp
            })
          })
        })
    }

    case 'LISTING_SALES_GET_SUCCESS': {
      for (const listingUuid in action.sales) {
        if (Object.prototype.hasOwnProperty.call(action.sales, listingUuid)) {
          const existingSale = state.sales[listingUuid]
          const newTimestamp = action.sales[listingUuid].timestamp || action.timestamp
          action.sales[listingUuid] = (existingSale && newTimestamp < existingSale.timestamp)
            ? existingSale
            : Object.assign({}, decodeListingSaleProperties(action.sales[listingUuid]), {
              timestamp: newTimestamp
            })
        }
      }
      return Object.assign({}, state, {
        sales: Object.assign({}, state.sales, action.sales)
      })
    }

    case 'LISTING_SALE_GET_INCREMENTS_SUCCESS':
      return Object.assign({}, state, {
        incrementTables: Object.assign({}, state.incrementTables, {
          [action?.listingUuid || 0]: action.increments
        })
      })

    case 'LISTING_SALE_GET_CUSTOM_INCREMENTS_SUCCESS': {
      const incrementTables = {}
      for (const listingUuid in action.increments) {
        if (Object.prototype.hasOwnProperty.call(action.increments, listingUuid)) {
          incrementTables[listingUuid] = action.increments[listingUuid]
        }
      }
      return Object.assign({}, state, {
        incrementTables: Object.assign({}, state.incrementTables, incrementTables)
      })
    }

    case 'LISTING_SALE_ACTIVE_LISTINGS_INITIALISE': {
      return Object.assign({}, state, {
        activeListings: action.listingUuids || []
      })
    }

    case 'LISTING_SALE_ADD_ACTIVE_LISTINGS': {
      const listingUuids = action.listingUuids || []
      return {
        ...state,
        activeListings: [...(state.activeListings || []), ...listingUuids.filter(uuid => !(state.activeListings || []).includes(uuid))]
      }
    }

    case 'LISTING_SALE_REMOVE_ACTIVE_LISTINGS': {
      const listingUuids = action.listingUuids || []
      return {
        ...state,
        activeListings: (state.activeListings || []).filter(uuid => !listingUuids.includes(uuid))
      }
    }

    default:
      return state
  }
}
